import { render, staticRenderFns } from "./DsfPracticeResult.vue?vue&type=template&id=20303780&"
import script from "./DsfPracticeResult.vue?vue&type=script&lang=js&"
export * from "./DsfPracticeResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/DsfPracticeResult.vue"
export default component.exports